import s from './styles.scss';
import { Container, Loader, enums } from 'edrolo-ui';

export const Skeleton = () => {
  return (
    <div className={s.skeleton}>
      <Container width={enums.Width.WIDE}>
        <Loader.Gradient width={enums.Size.SMALL} />
      </Container>
    </div>
  );
};
